export default "__VITE_ASSET__DwXwew$7__"